import { createRouter, createWebHistory } from "vue-router";
import Auth0 from "../components/auth/Auth0.vue";
import Logout from "../components/auth/Logout.vue";

import Home from "../views/Home.vue";
import KnowledgeSources from "../views/KnowledgeSources.vue";
import LlmQuotas from "../views/LlmQuotas.vue";
import ModelDeployments from "../views/ModelDeployments.vue"
import DeploymentCredentials from "../views/DeploymentCredentials.vue";
import SearchCredentials from "../views/SearchCredentials.vue";
import Skills from "../views/Skills.vue";
import SkillGroupings from "../views/SkillGroupings.vue";
import AiBots from "../views/AiBots.vue";
import UserGroups from "../views/UserGroups.vue";
import UserManagement from "../views/UserManagement.vue";
import UsageMetrics from "../views/UsageMetrics.vue";

export default function generateRouter(app, auth) {
    const routes = [
        { path: '/', name: 'home', component: Home },

        { path: '/users', name: 'users', component: UserManagement, meta: { authenticated: true }},
        { path: '/user-groups', name: 'user-groups', component: UserGroups, meta: { authenticated: true }},
        { path: '/knowledge-sources', name: 'knowledge-sources', component: KnowledgeSources, meta: { authenticated: true }},
        { path: '/ai-model-deployments', name: 'ai-model-deployments', component: ModelDeployments, meta: { authenticated: true }},
        { path: '/deployment-credentials', name: 'deployments-credentials', component: DeploymentCredentials, meta: { authenticated: true }},
        { path: '/search-credentials', name: 'search-credentials', component: SearchCredentials, meta: { authenticated: true }},
        { path: '/llm-quotas', name: 'llm-quotas', component: LlmQuotas, meta: { authenticated: true }},
        { path: '/agent-skills', name: 'agent-skills', component: Skills, meta: { authenticated: true }},
        { path: '/agent-skill-groupings', name: 'agent-skill-groupings', component: SkillGroupings, meta: { authenticated: true }},
        { path: '/ai-agents', name: 'ai-agents', component: AiBots, meta: { authenticated: true }},
        { path: '/usage-metrics', name: 'usage-metrics', component: UsageMetrics, meta: { authenticated: true }},

        { path: '/login/auth', name: 'auth', component: Auth0 },
        { path: '/logout', name: 'logout', component: Logout }
    ]

    const router = createRouter({
        history: createWebHistory(),
        routes,
    })
    router.beforeEach(async (to, from, next) => {
        if (import.meta.env.MODE !== 'production') {
            document.title = 'Sphere Admin (Test)'
        }

        await auth.checkSession()

        if (to?.meta?.authenticated) {
            if (!auth.isAuthenticated.value) {
                next('/')
                return
            }
        }

        next()
    })
    return router

}